export class ListClassificationCategoriesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "categories",
            "baseName": "categories",
            "type": "Array<ClassificationCategory>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListClassificationCategoriesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
